// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1nejJ","content":"styles_content__2KSGV","checkbox":"styles_checkbox__2h_7B","checkboxLabel":"styles_checkboxLabel__2uTcL"};